module.exports = __webpack_public_path__ + "static/media/facebook-login-573x102.7fded67c.png";